import { BaseComponent, define } from 'core';
import { SLAB_BATCHES_SELECTED } from 'events';
import 'component-modal';

// Teklif formu (snippets/slab-quote-modal.liquid). Seçili partileri "Available Slabs"
// section'ının event'inden alır ve modalı açar. Ne istendiği (numune / teklif)
// formdaki zorunlu alanda soruluyor. Gönderim native contact formu; Zoho kopyası aşağıda.
export class SlabQuoteForm extends BaseComponent {
  connectedCallback() {
    super.connectedCallback();
    this._modalId = this.dataset.modal;
    this._wrap = this.querySelector('[data-quote-batches-wrap]');
    this._list = this.querySelector('[data-quote-batches]');
    this._input = this.querySelector('[data-quote-batches-input]');
    this._need = this.querySelector('[data-quote-need]');

    // GÖNDERİM AJAX DEĞİL, bilerek: mağazada Shopify'ın storefront hCaptcha koruması
    // açık ve captcha script'i formun submit olayına kancalanıp jetonu o sırada
    // ekliyor. preventDefault edip fetch ile göndermek jetonu atlıyor ve Shopify
    // 403 "Verifying your connection" döndürüyor (ölçüldü). Bu yüzden form normal
    // POST ile gidiyor; sonuç sayfa yeniden yüklenince modalda gösteriliyor
    // (aşağıdaki modül seviyesindeki [data-slab-quote-result] açıcısı).
    // AJAX isteniyorsa yol: gönderimi app proxy'sine almak (trade-lead gibi),
    // orada captcha yerine kendi spam korumamız var.

    // Zoho'ya kopya: native gönderim aynen sürüyor (e-posta + hCaptcha), submit anında
    // aynı alanlar app proxy'sine de gidiyor, orada Sukru'ya ait bir Deal açılıyor
    // (sync app: app/routes/proxy.slab-quote.tsx). keepalive: sayfa hemen yeniden
    // yüklenirken istek yarıda kesilmesin. preventDefault YOK; kopya başarısız olsa da
    // müşterinin talebi e-postayla ulaşıyor.
    const form = this.closest('form');
    if (form) {
      form.addEventListener('submit', () => {
        try {
          fetch('/apps/sync/slab-quote', {
            method: 'POST',
            body: new FormData(form),
            keepalive: true,
            headers: { Accept: 'application/json' },
          }).catch(() => {});
        } catch (_) {
          // kopya gitmezse native gönderim etkilenmez
        }
      });
    }

    this.on(document, SLAB_BATCHES_SELECTED, (event) => {
      const batches = (event.detail && event.detail.batches) || [];
      this.setBatches(batches);
      // Parti seçip gelen müşteri teklif istiyor; formdaki soruyu boş bırakmıyoruz.
      // Değiştirebilir: alan normal bir seçim kutusu.
      if (this._need && this._need.dataset.quoteValue) this._need.value = this._need.dataset.quoteValue;
      this._openModal();
    });
  }

  // Liste fotoğraflı: taş görsel bir ürün, "Batch 43633-1-24" tek başına neyi
  // seçtiğini anlatmıyor. Gizli alan (e-postaya giden) düz METİN kalır.
  setBatches(batches) {
    const lines = batches.map((b) => this._describe(b));
    this._input.value = lines.join('; ');
    this._list.replaceChildren(
      ...batches.map((b, i) => {
        const li = document.createElement('li');
        li.className = 'flex items-center gap-3';

        const thumb = document.createElement('span');
        // 3:2 kutu: plaka fotoğrafları yatay, kare kırpma ince bir şerit bırakıyordu.
        thumb.className = 'h-12 w-[4.5rem] shrink-0 overflow-hidden rounded-control border border-border bg-white';
        if (b.image) {
          const img = document.createElement('img');
          img.src = b.image;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 72;
          img.height = 48;
          img.className = 'h-full w-full object-cover';
          thumb.appendChild(img);
        }
        li.appendChild(thumb);

        const text = document.createElement('span');
        text.className = 'min-w-0';
        text.textContent = lines[i];
        li.appendChild(text);
        return li;
      }),
    );
    this._wrap.hidden = batches.length === 0;
  }

  _describe(b) {
    const parts = [(this.dataset.batchLabel || '__batch__').replace('__batch__', b.batch || '')];
    if (b.location) parts.push(b.location);
    if (b.sqft > 0) parts.push(`${b.sqft.toLocaleString('en-US')} sq ft`);
    return parts.join(' · ');
  }

  _openModal() {
    const modal = document.getElementById(this._modalId);
    if (modal && typeof modal.open === 'function') modal.open();
  }
}

define('slab-quote-form', SlabQuoteForm);

// Gönderimden sonra Shopify sayfayı yeniden yükler; sonuç (başarı ya da hata) modalın
// içinde basılı gelir. Kullanıcı sonucu görsün diye modal kendiliğinden açılır.
document.querySelectorAll('modal-dialog [data-slab-quote-result]').forEach((result) => {
  const modal = result.closest('modal-dialog');
  customElements.whenDefined('modal-dialog').then(() => {
    requestAnimationFrame(() => {
      if (typeof modal.open === 'function') modal.open();
      result.focus({ preventScroll: true });
    });
  });
});
